module.exports = __webpack_public_path__ + "static/e866ee5e.left.png";